import { treaty } from "@elysiajs/eden";
import type { App } from "./server";

const client = treaty<App>(window.location.origin);

export async function fetchAbstracts() {
	const { data, error } = await client.api.abstracts.get();
	if (error) throw error;
	return data;
}

export async function fetchAbstract(id: string) {
	const { data, error } = await client.api.abstracts({ id }).get();
	if (error) throw error;
	return data;
}

export async function searchAbstracts(query: string) {
	const { data, error } = await client.api.search.get({
		query: { q: query },
	});
	if (error) throw error;
	return data;
}
